module.exports = __webpack_public_path__ + "img/logo-white.22a55abb.svg";